import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './App.scss';
import CaminoCasa from './components/organisms/camino-casa/caminoCasa';
import DataTreatmentReady from './components/organisms/data-treatment-ready/dataTreatmentReady';
import Diagnostico from './components/organisms/diagnositco/diagnostico';
import DiagnosticoPartialResult from './components/organisms/diagnostico-partial-result/diagnosticoPartialResult';
import DiagnosticoPartialStart from './components/organisms/diagnostico-partial-start/diagnosticoPartialStart';
import DiagnosticoPartial from './components/organisms/diagnostico-partial/diagnosticoPartial';
import DiagnosticoResult from './components/organisms/diagnostico-result/diagnosticoResult';
import DiagnosticoStart from './components/organisms/diagnostico-start/diagnosticoStart';
import NotLogged from './components/organisms/not-logged/notLogged';
import PropositosStart from './components/organisms/propositos-start/propositosStart';
import Propositos from './components/organisms/propositos/propositos';
import TratamientoDatos from './components/organisms/tratamiento-datos/tratamientoDatos';
import Layout from './shared/src/components/organisms/layout/layout';
import authContext from './shared/src/contexts/authContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
	const context = useContext(authContext);
	const { pathname } = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname])
	

	if (!context.gigyaAccount && !context.loading) {
		return (
			<Layout>
				<NotLogged />
			</Layout>
		)
	}

	return (
		<Layout notifySys={{container: ToastContainer, toast}}>
			<Routes>
				<Route path="/" element={
					<Navigate to="/propositos" />
				} />
				<Route path="/propositos" element={
					<PropositosStart />
				} />

				<Route path="/propositos/seleccionar" element={
					<Propositos />
				} />

				<Route path="/formulario-inicial/" element={
					<DiagnosticoPartialStart />
				} />

				<Route path="/formulario-inicial/tratamiento-datos" element={
					<TratamientoDatos />
				} />

				<Route path="/formulario-inicial/tratamiento-datos/listo" element={
					<DataTreatmentReady /> 
				} />

				<Route path="/formulario-inicial/preguntas" element={
					<DiagnosticoPartial />
				} />

				<Route path="/formulario-inicial/resultado" element={
					<DiagnosticoPartialResult />
				} />

				<Route path="/formulario-salud-educacion-financiera/" element={
					<DiagnosticoStart />
				} />

				<Route path="/formulario-salud-educacion-financiera/preguntas" element={
					<Diagnostico />
				} />

				<Route path="/formulario-salud-educacion-financiera/resultado" element={
					<DiagnosticoResult />
				} />

				<Route path="/camino-casa" element={
					<CaminoCasa />
				} />

				<Route path="*" element={
					<Navigate to="/" />
				} />
			</Routes>
		</Layout>
	);
}

export default App;
